import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout = () => {
  const location = useLocation();
  const isTelemetry = location.pathname === '/telemetry';

  return (
    <div className="min-h-screen bg-white selection:bg-zinc-900 selection:text-white font-sans flex flex-col">
      <Header />
      {/* 
        Add pt-20 to offset the fixed header. 
        For Telemetry, we ensure the main container doesn't overflow.
      */}
      <main className={`flex-grow pt-20 ${isTelemetry ? 'overflow-hidden' : ''}`}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;